import gql from "graphql-tag";

export const CREATE_CUSTOMER = gql`
	mutation CreateCustomer($customer: CustomerInput) {
		CreateCustomer(customer: $customer) {
			id
			name
			phoneNumber
			paymentCustomerId
			description
			emailId
			handle
			modifiedAt
			profileImageUrl
			address {
				zip
				line1
				line2
				state
				city
				timeZone
				country
				tag
			}
		}
	}
`;

export const UPDATE_CUSTOMER = gql`
	mutation UpdateCustomer($id: String, $customer: CustomerInput) {
		UpdateCustomer(id: $id, customer: $customer) {
			id
			name
			phoneNumber
			paymentCustomerId
			description
			emailId
			handle
			modifiedAt
			profileImageUrl
			address {
			    id
				zip
				line1
				line2
				state
				city
				country
				tag
			}
		}
	}
`;

export const REMOVE_PAYMENT_ID_FROM_CUSTOMER = gql`
	mutation RemovePaymentIdFromCustomer($id: String) {
		RemovePaymentIdFromCustomer(id: $id) {
			id
			name
			phoneNumber
			paymentCustomerId
			description
			emailId
			handle
			modifiedAt
			profileImageUrl
		}
	}
`;

export const GET_CUSTOMER_BY_ID = gql`
	query GetCustomerById($id: String) {
		GetCustomerById(id: $id) {
			id
			name
			phoneNumber
			paymentCustomerId
			description
			emailId
			handle
			modifiedAt
			paymentCustomerId
			profileImageUrl
		}
	}
`;

export const GET_CUSTOMER_BY_PHONE = gql`
	query GetCustomerByPhone($phone: String) {
		GetCustomerByPhone(phone: $phone) {
			id
			name
			phoneNumber
			paymentCustomerId
			description
			emailId
			handle
			modifiedAt
			paymentCustomerId
			profileImageUrl
			address {
			    id
				zip
				line1
				line2
				state
				city
				timeZone
				country
				tag
			}
		}
	}
`;
